export class ExtendedError extends Error {
  name = 'ExtendedError'
  code = 'ERROR'
  message = 'Error'

  constructor (body?: { name?: string, code?: string, message?: string }) {
    super(body && body.message)
    if (body) {
      this.name = body.name || this.name
      this.code = body.code || this.code
      this.message = body.message || this.message
    }
  }
}

export class ConnectionError extends ExtendedError {
  name = 'ConnectionError'
  code = 'CONNECTION_ERROR'
  message = 'User has no credentials'
}
